export type Maybe<T> = T | null
export type If<T, V> = { __typename: T } & V
export type Operation<Data, Variables = undefined> = {
  query: string
  variables: Variables
}
export type ById<T> = { [id: string]: T | undefined }

export enum Label {
  ZERO_POINT = 'ZERO_POINT',
  AFFILIATE = 'AFFILIATE',
  STAFF = 'STAFF',
  PRODUCT_LAUNCH = 'PRODUCT_LAUNCH',
  GIFTING_COMMITTEE = 'GIFTING_COMMITTEE',
  NOWSITE_ACTIVE = 'NOWSITE_ACTIVE',
  NOWSITE_NEED_SETUP = 'NOWSITE_NEED_SETUP',
  AFFILIATE_MISSING_W9 = 'AFFILIATE_MISSING_W9',
  AFFILIATE_MISSING_W8 = 'AFFILIATE_MISSING_W8',
  AFFILIATE_RECEIVES_PHYSICAL_CHECKS = 'AFFILIATE_RECEIVES_PHYSICAL_CHECKS',
  NEEDS_GS_AFFILIATE_OPT_IN = 'NEEDS_GS_AFFILIATE_OPT_IN',
  NEEDS_CUSTOMER_REFERRAL_OPT_IN = 'NEEDS_CUSTOMER_REFERRAL_OPT_IN',
  SHOULD_HIDE_REVOLUTION_OFFICE = 'SHOULD_HIDE_REVOLUTION_OFFICE',
}

export enum UserType {
  SP123 = 'SP123',
  S = 'S',
  C = 'C',
  RC = 'RC',
  D = 'D',
  GSA = 'GSA',
  SA = 'SA',
  BBC = 'BBC',
  BBD = 'BBD',
  MBC = 'MBC',
  MBD = 'MBD',
  PBC = 'PBC',
  PBD = 'PBD',
  JO = 'JO',
  ID = 'ID',
  MD = 'MD',
  WCS = 'WCS',
  WCG = 'WCG',
}

export enum Currency {
  SOC = 'SOC',
  USD = 'USD',
}

export enum CardType {
  POSTCARD = 'POSTCARD',
  FLATCARD = 'FLATCARD',
  TWO_PANEL = 'TWO_PANEL',
  THREE_PANEL = 'THREE_PANEL',
  TWO_PANEL_BIG = 'TWO_PANEL_BIG',
}

export enum CardPaperType {
  STD = 'STD',
  PRE = 'PRE',
  HVY = 'HVY',
}

export enum CurrencyType {
  POINT = 'POINT',
  EXPENSE = 'EXPENSE',
  FREE = 'FREE',
  USD = 'USD',
  CREDIT = 'CREDIT',
  CARDTOKEN = 'CARDTOKEN',
}

export enum LayoutCategory {
  BASIC_LAYOUTS = 'BASIC_LAYOUTS',
  BACK_PANELS = 'BACK_PANELS',
}

export enum Owner {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
}

export enum LayoutDimensions {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
  POSTCARD = 'POSTCARD',
}

export enum ReminderType {
  ANNIVERSARY = 'ANNIVERSARY',
  BIRTHDAY = 'BIRTHDAY',
  PROJECT = 'PROJECT',
}

export enum NewReminderType {
  ANNIVERSARY = 'ANNIVERSARY',
  BIRTHDAY = 'BIRTHDAY',
  CAMPAIGN = 'CAMPAIGN',
}

export enum NotificationType {
  ANNIVERSARY = 'ANNIVERSARY',
  BIRTHDAY = 'BIRTHDAY',
  CAMPAIGN = 'CAMPAIGN',
  REJECTED_CARDS = 'REJECTED_CARDS',
  HELD_PRODUCTION_INFOS = 'HELD_PRODUCTION_INFOS',
}

export enum TextAlignment {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

export enum CardStatus {
  PENDING = 'PENDING',
  FULFILLED = 'FULFILLED',
  REJECTED = 'REJECTED',
  HELD = 'HELD',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
}

export enum SendDelayType {
  IMM = 'IMM',
  BIR = 'BIR',
  ANN = 'ANN',
  SPE = 'SPE',
}

export enum SendDelayDelayType {
  DAY = 'DAY',
  WEE = 'WEE',
  MON = 'MON',
}

export enum SendDelayTimeType {
  BEF = 'BEF',
  AFT = 'AFT',
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  PAST_DUE = 'PAST_DUE',
  TRIALING = 'TRIALING',
  UNPAID = 'UNPAID',
}

export enum VerifyPhoneNumberFailureType {
  CODE_EXPIRED = 'CODE_EXPIRED',
  INCORRECT_CODE = 'INCORRECT_CODE',
  ALREADY_VERIFIED = 'ALREADY_VERIFIED',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  UNVERIFIED_ACCOUNT_FOUND = 'UNVERIFIED_ACCOUNT_FOUND',
  NO_VERIFIED_ACCOUNTS_FOUND = 'NO_VERIFIED_ACCOUNTS_FOUND',
}

export enum VerifyPhoneNumberSuccessType {
  SIGNED_INTO_EXISTING_ACCOUNT = 'SIGNED_INTO_EXISTING_ACCOUNT',
  CREATED_NEW_ACCOUNT = 'CREATED_NEW_ACCOUNT',
  UPDATED_EXISTING_ACCOUNT = 'UPDATED_EXISTING_ACCOUNT',
}

export type AccountInput = {
  username?: Maybe<string>
  password?: Maybe<string>
  email?: Maybe<string>
  firstName?: Maybe<string>
  lastName?: Maybe<string>
  shippingAddress?: Maybe<AddressInput>
  phoneNumber?: Maybe<string>
  stripeToken?: Maybe<string>
  plan?: Maybe<string>
  planAddon?: Maybe<string>
  expenseReload?: Maybe<ExpenseReloadInput>
  profileImage?: Maybe<string>
  sponsor?: Maybe<string>
  sponsorGenealogyId?: Maybe<string>
  sponsorSlug?: Maybe<string>
  isBetterWayPromo?: Maybe<boolean>
  settings?: Maybe<AccountSettingsInput>
  storefront?: Maybe<UpdateStorefrontInput>
}

export const AccountInput = ({
  username,
  password,
  email,
  firstName,
  lastName,
  shippingAddress,
  phoneNumber,
  stripeToken,
  plan,
  planAddon,
  expenseReload,
  profileImage,
  sponsor,
  sponsorGenealogyId,
  sponsorSlug,
  isBetterWayPromo,
  settings,
  storefront,
}: AccountInput = {}): AccountInput => ({
  username,
  password,
  email,
  firstName,
  lastName,
  shippingAddress: shippingAddress && AddressInput(shippingAddress),
  phoneNumber,
  stripeToken,
  plan,
  planAddon,
  expenseReload: expenseReload && ExpenseReloadInput(expenseReload),
  profileImage,
  sponsor,
  sponsorGenealogyId,
  sponsorSlug,
  isBetterWayPromo,
  settings: settings && AccountSettingsInput(settings),
  storefront: storefront && UpdateStorefrontInput(storefront),
})

export type AddressInput = {
  firstName: string
  lastName: string
  company: string
  address1: string
  address2: string
  city: string
  state: string
  postalCode: string
  country: string
}

export const AddressInput = ({
  firstName,
  lastName,
  company,
  address1,
  address2,
  city,
  state,
  postalCode,
  country,
}: AddressInput): AddressInput => ({
  firstName,
  lastName,
  company,
  address1,
  address2,
  city,
  state,
  postalCode,
  country,
})

export type ExpenseReloadInput = {
  purchaseAmount: number
  threshold: number
  isEnabled: boolean
}

export const ExpenseReloadInput = ({
  purchaseAmount,
  threshold,
  isEnabled,
}: ExpenseReloadInput): ExpenseReloadInput => ({
  purchaseAmount,
  threshold,
  isEnabled,
})

export type AccountSettingsInput = {
  defaultBackPanelId?: Maybe<string>
  receivesNotificationEmails?: Maybe<boolean>
  receivesPromoEmails?: Maybe<boolean>
  receivesReceiptEmails?: Maybe<boolean>
  receivesReminderEmails?: Maybe<boolean>
  printRecipientCompany?: Maybe<boolean>
  remindersAdvanceNoticeDays?: Maybe<number>
  remindersAdvanceNoticeDaysInternational?: Maybe<number>
}

export const AccountSettingsInput = ({
  defaultBackPanelId,
  receivesNotificationEmails,
  receivesPromoEmails,
  receivesReceiptEmails,
  receivesReminderEmails,
  printRecipientCompany,
  remindersAdvanceNoticeDays,
  remindersAdvanceNoticeDaysInternational,
}: AccountSettingsInput = {}): AccountSettingsInput => ({
  defaultBackPanelId,
  receivesNotificationEmails,
  receivesPromoEmails,
  receivesReceiptEmails,
  receivesReminderEmails,
  printRecipientCompany,
  remindersAdvanceNoticeDays,
  remindersAdvanceNoticeDaysInternational,
})

export type UpdateStorefrontInput = {
  slug?: Maybe<string>
  biography?: Maybe<string>
}

export const UpdateStorefrontInput = ({
  slug,
  biography,
}: UpdateStorefrontInput = {}): UpdateStorefrontInput => ({
  slug,
  biography,
})

export enum VerticalID {
  SENDOUTCARDS = 'SENDOUTCARDS',
  BLUE_42 = 'BLUE_42',
  BELLA_CADEAUX = 'BELLA_CADEAUX',
  STREAM_VA = 'STREAM_VA',
  STREAM_MARKETING = 'STREAM_MARKETING',
  PROMPTING_U = 'PROMPTING_U',
  GREENER_STILL = 'GREENER_STILL',
  BYDESIGN = 'BYDESIGN',
}

export type Args = {
  redirect_uri?: Maybe<string>
  marketshow?: Maybe<string>
}

export const Args = ({ redirect_uri, marketshow }: Args = {}): Args => ({
  redirect_uri,
  marketshow,
})

export type CreateCampaignInput = {
  id?: Maybe<string>
  name: string
  order?: Maybe<string>
  lines?: Maybe<LineInput[]>
  returnAddress?: Maybe<AddressInput>
}

export const CreateCampaignInput = ({
  id,
  name,
  order,
  lines,
  returnAddress,
}: CreateCampaignInput): CreateCampaignInput => ({
  id,
  name,
  order,
  lines: lines && lines.map(x => LineInput(x)),
  returnAddress: returnAddress && AddressInput(returnAddress),
})

export type LineInput = {
  card?: Maybe<string>
  giftVariation?: Maybe<string>
  sendDelay?: Maybe<SendDelayInput>
}

export const LineInput = ({
  card,
  giftVariation,
  sendDelay,
}: LineInput = {}): LineInput => ({
  card,
  giftVariation,
  sendDelay: sendDelay && SendDelayInput(sendDelay),
})

export type SendDelayInput = {
  type?: Maybe<SendDelayType>
  delayNumber?: Maybe<number>
  delayType?: Maybe<SendDelayDelayType>
  timeType?: Maybe<SendDelayTimeType>
  specificDate?: Maybe<string>
}

export const SendDelayInput = ({
  type,
  delayNumber,
  delayType,
  timeType,
  specificDate,
}: SendDelayInput = {}): SendDelayInput => ({
  type,
  delayNumber,
  delayType,
  timeType,
  specificDate,
})

export type CreateContactInput = {
  firstName?: Maybe<string>
  lastName?: Maybe<string>
  companyName?: Maybe<string>
  address1?: Maybe<string>
  address2?: Maybe<string>
  city?: Maybe<string>
  state?: Maybe<string>
  postalCode?: Maybe<string>
  country?: Maybe<string>
  birthday?: Maybe<OptionalYearDateInput>
  anniversary?: Maybe<OptionalYearDateInput>
  homePhone?: Maybe<string>
  cellNumber?: Maybe<string>
  cellPhone?: Maybe<string>
  workPhone?: Maybe<string>
  faxNumber?: Maybe<string>
  emailAddress?: Maybe<string>
  website?: Maybe<string>
  websites?: Maybe<string[]>
  groupName?: Maybe<string>
  groups?: Maybe<string[]>
  spouse?: Maybe<string>
  parent?: Maybe<string>
  isPrimary?: Maybe<boolean>
  notes?: Maybe<NoteInput[]>
  id?: Maybe<string>
  spouseName?: Maybe<string>
  spouseBirthday?: Maybe<OptionalYearDateInput>
}

export const CreateContactInput = ({
  firstName,
  lastName,
  companyName,
  address1,
  address2,
  city,
  state,
  postalCode,
  country,
  birthday,
  anniversary,
  homePhone,
  cellNumber,
  cellPhone,
  workPhone,
  faxNumber,
  emailAddress,
  website,
  websites,
  groupName,
  groups,
  spouse,
  parent,
  isPrimary,
  notes,
  id,
  spouseName,
  spouseBirthday,
}: CreateContactInput = {}): CreateContactInput => ({
  firstName,
  lastName,
  companyName,
  address1,
  address2,
  city,
  state,
  postalCode,
  country,
  birthday: birthday && OptionalYearDateInput(birthday),
  anniversary: anniversary && OptionalYearDateInput(anniversary),
  homePhone,
  cellNumber,
  cellPhone,
  workPhone,
  faxNumber,
  emailAddress,
  website,
  websites,
  groupName,
  groups,
  spouse,
  parent,
  isPrimary,
  notes: notes && notes.map(x => NoteInput(x)),
  id,
  spouseName,
  spouseBirthday: spouseBirthday && OptionalYearDateInput(spouseBirthday),
})

export type OptionalYearDateInput = {
  day: number
  month: number
  year?: Maybe<number>
}

export const OptionalYearDateInput = ({
  day,
  month,
  year,
}: OptionalYearDateInput): OptionalYearDateInput => ({
  day,
  month,
  year,
})

export type NoteInput = {
  id: string
  text: string
  date?: Maybe<CalendarDateInput>
}

export const NoteInput = ({ id, text, date }: NoteInput): NoteInput => ({
  id,
  text,
  date: date && CalendarDateInput(date),
})

export type CalendarDateInput = {
  day: number
  month: number
  year: number
}

export const CalendarDateInput = ({
  day,
  month,
  year,
}: CalendarDateInput): CalendarDateInput => ({
  day,
  month,
  year,
})

export type CreateGroupInput = {
  id?: Maybe<string>
  name: string
  description?: Maybe<string>
  members?: Maybe<string[]>
  groups?: Maybe<string[]>
}

export const CreateGroupInput = ({
  id,
  name,
  description,
  members,
  groups,
}: CreateGroupInput): CreateGroupInput => ({
  id,
  name,
  description,
  members,
  groups,
})

export type CreateOrderInput = {
  campaign?: Maybe<string>
  lines?: Maybe<LineInput[]>
  contacts?: Maybe<string[]>
  contactsFromGroups?: Maybe<string[]>
  groups?: Maybe<string[]>
  returnAddress?: Maybe<AddressInput>
  id?: Maybe<string>
}

export const CreateOrderInput = ({
  campaign,
  lines,
  contacts,
  contactsFromGroups,
  groups,
  returnAddress,
  id,
}: CreateOrderInput = {}): CreateOrderInput => ({
  campaign,
  lines: lines && lines.map(x => LineInput(x)),
  contacts,
  contactsFromGroups,
  groups,
  returnAddress: returnAddress && AddressInput(returnAddress),
  id,
})

export type PanelInput = {
  location: number
  isFullBleed: boolean
  backgroundColor?: Maybe<ColorInput>
  backgroundColorObject?: Maybe<ColorInput>
  elements: ElementInput[]
}

export const PanelInput = ({
  location,
  isFullBleed,
  backgroundColor,
  backgroundColorObject,
  elements,
}: PanelInput): PanelInput => ({
  location,
  isFullBleed,
  backgroundColor: backgroundColor && ColorInput(backgroundColor),
  backgroundColorObject:
    backgroundColorObject && ColorInput(backgroundColorObject),
  elements: elements.map(x => ElementInput(x)),
})

export type ColorInput = {
  red: number
  green: number
  blue: number
}

export const ColorInput = ({ red, green, blue }: ColorInput): ColorInput => ({
  red,
  green,
  blue,
})

export type ElementInput = {
  x: number
  y: number
  z: number
  width: number
  height: number
  rotation: number
  locked: boolean
  image?: Maybe<ElementPictureInput>
  text?: Maybe<ElementTextInput>
}

export const ElementInput = ({
  x,
  y,
  z,
  width,
  height,
  rotation,
  locked,
  image,
  text,
}: ElementInput): ElementInput => ({
  x,
  y,
  z,
  width,
  height,
  rotation,
  locked,
  image: image && ElementPictureInput(image),
  text: text && ElementTextInput(text),
})

export type ElementPictureInput = {
  image?: Maybe<string>
  position?: Maybe<PositionInput>
  scale?: Maybe<number>
  filter?: Maybe<string>
}

export const ElementPictureInput = ({
  image,
  position,
  scale,
  filter,
}: ElementPictureInput = {}): ElementPictureInput => ({
  image,
  position: position && PositionInput(position),
  scale,
  filter,
})

export type PositionInput = {
  x: number
  y: number
}

export const PositionInput = ({ x, y }: PositionInput): PositionInput => ({
  x,
  y,
})

export type ElementTextInput = {
  paragraphs?: Maybe<ParagraphInput[]>
}

export const ElementTextInput = ({
  paragraphs,
}: ElementTextInput = {}): ElementTextInput => ({
  paragraphs: paragraphs && paragraphs.map(x => ParagraphInput(x)),
})

export type ParagraphInput = {
  textFragments: TextFragmentInput[]
  alignment: TextAlignment
}

export const ParagraphInput = ({
  textFragments,
  alignment,
}: ParagraphInput): ParagraphInput => ({
  textFragments: textFragments.map(x => TextFragmentInput(x)),
  alignment,
})

export type TextFragmentInput = {
  text: string
  textColor: ColorInput
  font: string
  fontSize: number
  isReplacement: boolean
}

export const TextFragmentInput = ({
  text,
  textColor,
  font,
  fontSize,
  isReplacement,
}: TextFragmentInput): TextFragmentInput => ({
  text,
  textColor: ColorInput(textColor),
  font,
  fontSize,
  isReplacement,
})

export type UpdateContactInput = {
  firstName?: Maybe<string>
  lastName?: Maybe<string>
  companyName?: Maybe<string>
  address1?: Maybe<string>
  address2?: Maybe<string>
  city?: Maybe<string>
  state?: Maybe<string>
  postalCode?: Maybe<string>
  country?: Maybe<string>
  birthday?: Maybe<OptionalYearDateInput>
  anniversary?: Maybe<OptionalYearDateInput>
  homePhone?: Maybe<string>
  cellNumber?: Maybe<string>
  cellPhone?: Maybe<string>
  workPhone?: Maybe<string>
  faxNumber?: Maybe<string>
  emailAddress?: Maybe<string>
  website?: Maybe<string>
  websites?: Maybe<string[]>
  groupName?: Maybe<string>
  groups?: Maybe<string[]>
  spouse?: Maybe<string>
  parent?: Maybe<string>
  isPrimary?: Maybe<boolean>
  notes?: Maybe<NoteInput[]>
  id: string
}

export const UpdateContactInput = ({
  firstName,
  lastName,
  companyName,
  address1,
  address2,
  city,
  state,
  postalCode,
  country,
  birthday,
  anniversary,
  homePhone,
  cellNumber,
  cellPhone,
  workPhone,
  faxNumber,
  emailAddress,
  website,
  websites,
  groupName,
  groups,
  spouse,
  parent,
  isPrimary,
  notes,
  id,
}: UpdateContactInput): UpdateContactInput => ({
  firstName,
  lastName,
  companyName,
  address1,
  address2,
  city,
  state,
  postalCode,
  country,
  birthday: birthday && OptionalYearDateInput(birthday),
  anniversary: anniversary && OptionalYearDateInput(anniversary),
  homePhone,
  cellNumber,
  cellPhone,
  workPhone,
  faxNumber,
  emailAddress,
  website,
  websites,
  groupName,
  groups,
  spouse,
  parent,
  isPrimary,
  notes: notes && notes.map(x => NoteInput(x)),
  id,
})

export type PhoneNumberInput = {
  countryIsoCode: string
  nationalNumber: string
  extension?: Maybe<string>
  numberOfLeadingZeros?: Maybe<number>
  preferredDomesticCarrierCode?: Maybe<string>
}

export const PhoneNumberInput = ({
  countryIsoCode,
  nationalNumber,
  extension,
  numberOfLeadingZeros,
  preferredDomesticCarrierCode,
}: PhoneNumberInput): PhoneNumberInput => ({
  countryIsoCode,
  nationalNumber,
  extension,
  numberOfLeadingZeros,
  preferredDomesticCarrierCode,
})

export enum RequestPhoneNumberVerificationFailureType {
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
}

export type SubscriptionInput = {
  id?: Maybe<string>
  plan?: Maybe<string>
  cancelAtPeriodEnd?: Maybe<boolean>
}

export const SubscriptionInput = ({
  id,
  plan,
  cancelAtPeriodEnd,
}: SubscriptionInput = {}): SubscriptionInput => ({
  id,
  plan,
  cancelAtPeriodEnd,
})

export type UpdateCampaignInput = {
  id: string
  name?: Maybe<string>
  lines?: Maybe<LineInput[]>
  returnAddress?: Maybe<AddressInput>
}

export const UpdateCampaignInput = ({
  id,
  name,
  lines,
  returnAddress,
}: UpdateCampaignInput): UpdateCampaignInput => ({
  id,
  name,
  lines: lines && lines.map(x => LineInput(x)),
  returnAddress: returnAddress && AddressInput(returnAddress),
})

export type UpdateCardInput = {
  id: string
  recipient?: Maybe<string>
  paperType?: Maybe<CardPaperType>
  panels?: Maybe<PanelInput[]>
}

export const UpdateCardInput = ({
  id,
  recipient,
  paperType,
  panels,
}: UpdateCardInput): UpdateCardInput => ({
  id,
  recipient,
  paperType,
  panels: panels && panels.map(x => PanelInput(x)),
})

export type UpdateGroupInput = {
  id: string
  name?: Maybe<string>
  description?: Maybe<string>
  members?: Maybe<string[]>
  newMembers?: Maybe<string[]>
}

export const UpdateGroupInput = ({
  id,
  name,
  description,
  members,
  newMembers,
}: UpdateGroupInput): UpdateGroupInput => ({
  id,
  name,
  description,
  members,
  newMembers,
})

export type UpdateOrderInput = {
  campaign?: Maybe<string>
  lines?: Maybe<LineInput[]>
  contacts?: Maybe<string[]>
  contactsFromGroups?: Maybe<string[]>
  groups?: Maybe<string[]>
  returnAddress?: Maybe<AddressInput>
  id: string
}

export const UpdateOrderInput = ({
  campaign,
  lines,
  contacts,
  contactsFromGroups,
  groups,
  returnAddress,
  id,
}: UpdateOrderInput): UpdateOrderInput => ({
  campaign,
  lines: lines && lines.map(x => LineInput(x)),
  contacts,
  contactsFromGroups,
  groups,
  returnAddress: returnAddress && AddressInput(returnAddress),
  id,
})

export type UpdateProductionInfoInput = {
  productionId: string
  dateToSend?: Maybe<string>
}

export const UpdateProductionInfoInput = ({
  productionId,
  dateToSend,
}: UpdateProductionInfoInput): UpdateProductionInfoInput => ({
  productionId,
  dateToSend,
})

export type RecipientInput = {
  id: string
  address: AddressInput
}

export const RecipientInput = ({
  id,
  address,
}: RecipientInput): RecipientInput => ({
  id,
  address: AddressInput(address),
})

export type UserLabelOverrideInput = {
  label: OverridableUserLabel
  action: UserLabelOverrideAction
}

export const UserLabelOverrideInput = ({
  label,
  action,
}: UserLabelOverrideInput): UserLabelOverrideInput => ({
  label,
  action,
})

export enum OverridableUserLabel {
  AFFILIATE_MISSING_W9 = 'AFFILIATE_MISSING_W9',
  AFFILIATE_MISSING_W8 = 'AFFILIATE_MISSING_W8',
  AFFILIATE_RECEIVES_PHYSICAL_CHECKS = 'AFFILIATE_RECEIVES_PHYSICAL_CHECKS',
  NEEDS_GS_AFFILIATE_OPT_IN = 'NEEDS_GS_AFFILIATE_OPT_IN',
  NEEDS_CUSTOMER_REFERRAL_OPT_IN = 'NEEDS_CUSTOMER_REFERRAL_OPT_IN',
  SHOULD_HIDE_REVOLUTION_OFFICE = 'SHOULD_HIDE_REVOLUTION_OFFICE',
}

export enum UserLabelOverrideAction {
  INCLUDE = 'INCLUDE',
  EXCLUDE = 'EXCLUDE',
  DISABLE = 'DISABLE',
}

export type NormalizedContact = {
  lastName?: string
  notes?: {
    id: string
    text: string
    date: Maybe<{
      day: number
      month: number
      year: number
    }>
  }[]
  __typename: 'Contact'
  faxNumber?: Maybe<string>
  parent?: Maybe<{
    __typename: 'Contact'
    id: string
  }>
  city?: string
  cellPhone?: Maybe<string>
  homePhone?: Maybe<string>
  anniversary?: Maybe<{
    day: number
    month: number
    year: Maybe<number>
  }>
  state?: string
  groups?: {
    __typename: 'Group'
    id: string
  }[]
  spouse?: Maybe<{
    __typename: 'Contact'
    id: string
  }>
  country?: Maybe<string>
  emailAddress?: Maybe<string>
  postalCode?: string
  isPrimary?: boolean
  website?: string
  id: string
  firstName?: string
  company?: string
  workPhone?: Maybe<string>
  birthday?: Maybe<{
    day: number
    month: number
    year: Maybe<number>
  }>
  address1?: string
  address2?: string
}

export type NormalizedProductionInfo = {
  trackingInfo: Maybe<{
    trackingNumber: string
    url: Maybe<string>
  }>
  __typename: 'ProductionInfo'
  rejectedCards: {
    id: string
  }[]
  rejectionReason: Maybe<string>
  frontPreviewUrl: string
  dateToSend: Maybe<string>
  status: CardStatus
  recipient: Maybe<{
    __typename: 'Recipient'
    id: string
  }>
  id: string
  hold: boolean
  fulfilled: Maybe<string>
}

export type NormalizedMarketingParagraph = {
  __typename: 'MarketingParagraph'
  createdAt: string
  updatedAt: string
  id: string
  title: string
  content: string
}

export type NormalizedCreditCard = {
  __typename: 'CreditCard'
  id: string
  brand: string
  last4: string
  expMonth: number
  expYear: number
  object: string
}

export type NormalizedInvite = {
  __typename: 'Invite'
  id: string
  createdAt: string
  prospect: Maybe<{
    __typename: 'Prospect'
    id: string
  }>
  socProContact: Maybe<{
    lastName: string
    zip: string
    __typename: 'SocProContact'
    city: string
    metadataBlob: string
    homePhone: string
    state: string
    address: string
    smsPhone: string
    country: string
    fullName: string
    contactId: string
    firstName: string
    email: string
    workPhone: string
    address2: string
  }>
  utmStream: Maybe<string>
  hasProspectJoined: boolean
  hasSentCard: boolean
}

export type NormalizedLayout = {
  __typename: 'Layout'
  id: string
  category: Maybe<LayoutCategory>
  owner: Owner
  dimensions: Maybe<LayoutDimensions>
  thumbnail: {
    url: string
  }
  panel?: {
    isFullBleed: boolean
    width: number
    previewUrl: string
    height: number
    name: string
    isLocked: boolean
    backgroundColor: Maybe<{
      red: number
      green: number
      blue: number
    }>
    location: number
    elements: {
      width: number
      height: number
      locked: boolean
      text: Maybe<{
        paragraphs: {
          textFragments: {
            text: string
            textColor: {
              red: number
              green: number
              blue: number
            }
            font: {
              id: string
              fontName: string
            }
            fontSize: number
            isReplacement: boolean
          }[]
          alignment: TextAlignment
        }[]
      }>
      x: number
      y: number
      z: number
      image: Maybe<{
        image: Maybe<{
          id: string
          url: string
          smallThumb: string
          width: number
          height: number
        }>
        position: {
          x: number
          y: number
        }
        scale: number
        filter: Maybe<{
          name: string
        }>
      }>
      rotation: number
    }[]
  }
}

export type NormalizedNotification = {
  __typename: 'Notification'
  message: Maybe<string>
  linkText: Maybe<string>
  data: Maybe<string>
  acceptText: Maybe<string>
  denyText: Maybe<string>
  type: Maybe<NotificationType>
  link: Maybe<string>
  id: string
  createdAt: string
}

export type NormalizedUser = {
  __typename: 'User'
  id: string
  firstName: string
  lastName: string
  email: string
  genealogyId: number
  storefront: Maybe<{
    slug: Maybe<string>
    mugshot: Maybe<{
      url: string
    }>
    biography: Maybe<string>
  }>
  shippingAddress?: Maybe<{
    city: string
    state: string
  }>
}

export type NormalizedProspect = {
  __typename: 'Prospect'
  id: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  address: Maybe<{
    lastName: string
    city: string
    state: string
    country: string
    postalCode: string
    firstName: string
    company: string
    address1: string
    address2: string
  }>
}

export type NormalizedCardCategory = {
  __typename: 'CardCategory'
  id: string
  description: string
  cards: {
    __typename: 'SendableCard'
    id: string
  }[]
}

export type NormalizedOrder = {
  isSent?: boolean
  returnAddress?: Maybe<{
    lastName: string
    city: string
    state: string
    country: string
    postalCode: string
    firstName: string
    company: string
    address1: string
    address2: string
  }>
  __typename: 'Order'
  invalidContacts?: {
    id: string
  }[]
  isSendable?: boolean
  cost?: {
    total: {
      asString: string
      currency: CurrencyType
      amount: number
    }[]
    entries: {
      label: string
      asString: string
      currency: CurrencyType
      amount: number
    }[]
  }
  updatedAt?: string
  campaign?: Maybe<{
    __typename: 'Campaign'
    id: string
  }>
  contacts?: {
    __typename: 'Contact'
    id: string
  }[]
  groups?: {
    id: string
    name: string
    members: {
      id: string
    }[]
  }[]
  warnings?: {
    code: Maybe<number>
    message: Maybe<string>
  }[]
  id: string
  createdAt?: string
  minimalLines?: {
    card: Maybe<{
      frontPreviewUrl: string
    }>
    giftVariation: Maybe<{
      imageUrls: string[]
    }>
  }[]
  lines?: {
    card: Maybe<{
      __typename: 'Card'
      id: string
    }>
    giftVariation: Maybe<{
      points: {
        amount: number
        currency: Currency
        description: string
      }
      packaging: Maybe<string>
      price: {
        asString: string
        currency: CurrencyType
        amount: number
      }
      name: string
      shipping: Maybe<string>
      defaultImageUrl: string
      contents: Maybe<string>
      id: string
      description: Maybe<string>
      imageUrls: string[]
    }>
    sendDelay: {
      type: SendDelayType
      delayNumber: Maybe<number>
      delayType: SendDelayDelayType
      timeType: SendDelayTimeType
      specificDate: string
    }
    cost: {
      total: {
        asString: string
        currency: CurrencyType
        amount: number
      }[]
      entries: {
        label: string
        asString: string
        currency: CurrencyType
        amount: number
      }[]
    }
    baseCost: {
      total: {
        asString: string
        currency: CurrencyType
        amount: number
      }[]
      entries: {
        label: string
        asString: string
        currency: CurrencyType
        amount: number
      }[]
    }
    recipientCount: number
  }[]
}

export type NormalizedCampaignShare = {
  __typename: 'CampaignShare'
  id: string
  fromName: string
  dateShared: string
  campaign: {
    name: string
  }
}

export type NormalizedCampaign = {
  __typename: 'Campaign'
  id: string
  name: string
  isShareable?: boolean
  lines?: {
    name: Maybe<string>
    card: Maybe<{
      __typename: 'Card'
      id: string
    }>
    giftVariation: Maybe<{
      points: {
        amount: number
        currency: Currency
        description: string
      }
      packaging: Maybe<string>
      price: {
        asString: string
        currency: CurrencyType
        amount: number
      }
      name: string
      shipping: Maybe<string>
      defaultImageUrl: string
      contents: Maybe<string>
      id: string
      description: Maybe<string>
      imageUrls: string[]
    }>
    sendDelay: {
      type: SendDelayType
      delayNumber: Maybe<number>
      delayType: SendDelayDelayType
      timeType: SendDelayTimeType
      specificDate: string
    }
  }[]
  minimalLines?: {
    card: Maybe<{
      id: string
      isHorizontal: boolean
      frontPreviewUrl: string
    }>
    giftVariation: Maybe<{
      defaultImageUrl: string
    }>
  }[]
  createdAt?: string
}

export type NormalizedGift = {
  id: string
  realId: string
  __typename: 'Gift'
  name: string
  defaultImageUrl: string
  defaultVariation: Maybe<{
    points: {
      amount: number
      currency: Currency
      description: string
    }
    packaging: Maybe<string>
    price: {
      asString: string
      currency: CurrencyType
      amount: number
    }
    name: string
    shipping: Maybe<string>
    defaultImageUrl: string
    contents: Maybe<string>
    id: string
    description: Maybe<string>
    imageUrls: string[]
  }>
  variations?: {
    points: {
      amount: number
      currency: Currency
      description: string
    }
    packaging: Maybe<string>
    price: {
      asString: string
      currency: CurrencyType
      amount: number
    }
    name: string
    shipping: Maybe<string>
    defaultImageUrl: string
    contents: Maybe<string>
    id: string
    description: Maybe<string>
    imageUrls: string[]
  }[]
}

export type NormalizedCard = {
  detailedSendableCard?: Maybe<{
    variations: {
      isFavorite: boolean
      cardTemplate: Maybe<{
        backPanelLocation: number
        panels: {
          isFullBleed: boolean
          width: number
          previewUrl: string
          height: number
          name: string
          isLocked: boolean
          backgroundColor: Maybe<{
            red: number
            green: number
            blue: number
          }>
          location: number
          elements: {
            width: number
            height: number
            locked: boolean
            text: Maybe<{
              paragraphs: {
                textFragments: {
                  text: string
                  textColor: {
                    red: number
                    green: number
                    blue: number
                  }
                  font: {
                    id: string
                    fontName: string
                  }
                  fontSize: number
                  isReplacement: boolean
                }[]
                alignment: TextAlignment
              }[]
            }>
            x: number
            y: number
            z: number
            image: Maybe<{
              image: Maybe<{
                id: string
                url: string
                smallThumb: string
                width: number
                height: number
              }>
              position: {
                x: number
                y: number
              }
              scale: number
              filter: Maybe<{
                name: string
              }>
            }>
            rotation: number
          }[]
        }[]
      }>
      isPremium: boolean
      cost: {
        total: {
          asString: string
        }[]
      }
      isHorizontal: boolean
      variationColor: string
      frontImage: {
        __typename: 'Image'
        id: string
      }
      title: string
      id: string
      insideRightImage: Maybe<{
        __typename: 'Image'
        id: string
      }>
      description: string
    }[]
    isFavorite: boolean
    cardTemplate: Maybe<{
      backPanelLocation: number
      panels: {
        isFullBleed: boolean
        width: number
        previewUrl: string
        height: number
        name: string
        isLocked: boolean
        backgroundColor: Maybe<{
          red: number
          green: number
          blue: number
        }>
        location: number
        elements: {
          width: number
          height: number
          locked: boolean
          text: Maybe<{
            paragraphs: {
              textFragments: {
                text: string
                textColor: {
                  red: number
                  green: number
                  blue: number
                }
                font: {
                  id: string
                  fontName: string
                }
                fontSize: number
                isReplacement: boolean
              }[]
              alignment: TextAlignment
            }[]
          }>
          x: number
          y: number
          z: number
          image: Maybe<{
            image: Maybe<{
              id: string
              url: string
              smallThumb: string
              width: number
              height: number
            }>
            position: {
              x: number
              y: number
            }
            scale: number
            filter: Maybe<{
              name: string
            }>
          }>
          rotation: number
        }[]
      }[]
    }>
    isPremium: boolean
    cost: {
      total: {
        asString: string
      }[]
    }
    isHorizontal: boolean
    variationColor: string
    frontImage: {
      __typename: 'Image'
      id: string
    }
    title: string
    id: string
    insideRightImage: Maybe<{
      __typename: 'Image'
      id: string
    }>
    description: string
  }>
  insidePreviewUrl?: Maybe<string>
  __typename: 'Card'
  paperType?: CardPaperType
  cost?: {
    total: {
      asString: string
      currency: CurrencyType
      amount: number
    }[]
    entries: {
      label: string
      asString: string
      currency: CurrencyType
      amount: number
    }[]
  }
  backPreviewUrl?: string
  isHorizontal: boolean
  updatedAt?: string
  panels?: {
    isFullBleed: boolean
    width: number
    previewUrl: string
    height: number
    name: string
    isLocked: boolean
    backgroundColor: Maybe<{
      red: number
      green: number
      blue: number
    }>
    location: number
    elements: {
      width: number
      height: number
      locked: boolean
      text: Maybe<{
        paragraphs: {
          textFragments: {
            text: string
            textColor: {
              red: number
              green: number
              blue: number
            }
            font: {
              id: string
              fontName: string
            }
            fontSize: number
            isReplacement: boolean
          }[]
          alignment: TextAlignment
        }[]
      }>
      x: number
      y: number
      z: number
      image: Maybe<{
        image: Maybe<{
          id: string
          url: string
          smallThumb: string
          width: number
          height: number
        }>
        position: {
          x: number
          y: number
        }
        scale: number
        filter: Maybe<{
          name: string
        }>
      }>
      rotation: number
    }[]
  }[]
  frontPreviewUrl: string
  minimalPanels?: {
    __typename: 'Panel'
    name: string
    previewUrl: string
    isFullBleed: boolean
    width: number
    height: number
  }[]
  backPanelLocation?: number
  sendableCard?: Maybe<{
    id: string
    title: string
  }>
  showInPicturePlus?: boolean
  tinyThumb?: string
  type?: CardType
  id: string
  flapPreviewUrl?: Maybe<string>
}

export type NormalizedBankAccount = {
  __typename: 'BankAccount'
  id: string
  bankName: string
  object: string
  last4: string
  accountHolderName: string
}

export type NormalizedItemCategory = {
  children?: {
    __typename: 'ItemCategory'
    id: string
  }[]
  __typename: 'ItemCategory'
  id: string
  name: string
  backgroundImageUrl: Maybe<string>
  items: {
    __typename: 'Item'
    id: string
  }[]
}

export type NormalizedReminder = {
  contact: {
    id: string
    firstName: string
    lastName: string
    birthday: Maybe<{
      day: number
      month: number
    }>
    anniversary: Maybe<{
      day: number
      month: number
    }>
  }
  __typename: 'Reminder'
  message: Maybe<string>
  eventDate: Maybe<string>
  campaign: Maybe<{
    id: string
    name: string
  }>
  title: string
  newType: NewReminderType
  type: ReminderType
  id: string
}

export type NormalizedSendableCard = {
  variations?: {
    isFavorite: boolean
    cardTemplate: Maybe<{
      backPanelLocation: number
      panels: {
        isFullBleed: boolean
        width: number
        previewUrl: string
        height: number
        name: string
        isLocked: boolean
        backgroundColor: Maybe<{
          red: number
          green: number
          blue: number
        }>
        location: number
        elements: {
          width: number
          height: number
          locked: boolean
          text: Maybe<{
            paragraphs: {
              textFragments: {
                text: string
                textColor: {
                  red: number
                  green: number
                  blue: number
                }
                font: {
                  id: string
                  fontName: string
                }
                fontSize: number
                isReplacement: boolean
              }[]
              alignment: TextAlignment
            }[]
          }>
          x: number
          y: number
          z: number
          image: Maybe<{
            image: Maybe<{
              id: string
              url: string
              smallThumb: string
              width: number
              height: number
            }>
            position: {
              x: number
              y: number
            }
            scale: number
            filter: Maybe<{
              name: string
            }>
          }>
          rotation: number
        }[]
      }[]
    }>
    isPremium: boolean
    cost: {
      total: {
        asString: string
      }[]
    }
    isHorizontal: boolean
    variationColor: string
    frontImage: {
      __typename: 'Image'
      id: string
    }
    title: string
    id: string
    insideRightImage: Maybe<{
      __typename: 'Image'
      id: string
    }>
    description: string
  }[]
  __typename: 'SendableCard'
  isFavorite: boolean
  cardTemplate?: Maybe<{
    backPanelLocation: number
    panels: {
      isFullBleed: boolean
      width: number
      previewUrl: string
      height: number
      name: string
      isLocked: boolean
      backgroundColor: Maybe<{
        red: number
        green: number
        blue: number
      }>
      location: number
      elements: {
        width: number
        height: number
        locked: boolean
        text: Maybe<{
          paragraphs: {
            textFragments: {
              text: string
              textColor: {
                red: number
                green: number
                blue: number
              }
              font: {
                id: string
                fontName: string
              }
              fontSize: number
              isReplacement: boolean
            }[]
            alignment: TextAlignment
          }[]
        }>
        x: number
        y: number
        z: number
        image: Maybe<{
          image: Maybe<{
            id: string
            url: string
            smallThumb: string
            width: number
            height: number
          }>
          position: {
            x: number
            y: number
          }
          scale: number
          filter: Maybe<{
            name: string
          }>
        }>
        rotation: number
      }[]
    }[]
  }>
  isPremium: boolean
  cost?: {
    total: {
      asString: string
      amount: number
    }[]
  }
  isHorizontal: boolean
  variationColor: string
  frontImage: {
    __typename: 'Image'
    id: string
  }
  title: string
  id: string
  insideRightImage?: Maybe<{
    __typename: 'Image'
    id: string
  }>
  description?: string
}

export type NormalizedItem = {
  __typename: 'Item'
  id: string
  description: Maybe<string>
  itemCode: string
  price: number
  name: Maybe<string>
  image: Maybe<string>
  campaign: Maybe<{
    __typename: 'Campaign'
    id: string
  }>
}

export type NormalizedRecipient = {
  __typename: 'Recipient'
  id: string
  paymentFailure: Maybe<{
    id: string
  }>
  contact: Maybe<{
    id: string
    firstName: string
    lastName: string
  }>
  address: Maybe<{
    lastName: string
    city: string
    state: string
    userVerified: boolean
    errorMessages: string[]
    country: string
    postalCode: string
    firstName: string
    company: string
    address1: string
    address2: string
  }>
  gift: Maybe<{
    name: string
    defaultImageUrl: string
  }>
  card: Maybe<{
    frontPreviewUrl: string
    id: string
    sendableCard: Maybe<{
      title: string
    }>
  }>
}

export type NormalizedImage = {
  __typename: 'Image'
  id: string
  url: string
  width: number
  height: number
  smallThumb: string
  mediumThumb?: string
  createdAt?: string
}

export type NormalizedMarketingMultiParagraph = {
  __typename: 'MarketingMultiParagraph'
  createdAt: string
  updatedAt: string
  id: string
  title: string
  content: string
}

export type NormalizedCollection = {
  backgroundImageUrl: Maybe<string>
  cards: {
    __typename: 'SendableCard'
    id: string
  }[]
  __typename: 'Collection'
  reasonToSend: boolean
  backgroundStartColor: string
  textColor: string
  backgroundEndColor: string
  title: string
  id: string
  description: string
}

export type NormalizedGroup = {
  __typename: 'Group'
  id: string
  name: string
  members?: {
    __typename: 'Contact'
    id: string
  }[]
  description?: string
}

export type NormalizedContactShare = {
  __typename: 'ContactShare'
  id: string
  contact: {
    __typename: 'Contact'
    id: string
  }
  fromUser: {
    username: string
    firstName: string
    lastName: string
    email: string
  }
  createdAt: string
}

export type NormalizedData = {
  Contact: ById<NormalizedContact>
  ProductionInfo: ById<NormalizedProductionInfo>
  MarketingParagraph: ById<NormalizedMarketingParagraph>
  CreditCard: ById<NormalizedCreditCard>
  Invite: ById<NormalizedInvite>
  Layout: ById<NormalizedLayout>
  Notification: ById<NormalizedNotification>
  User: ById<NormalizedUser>
  Prospect: ById<NormalizedProspect>
  CardCategory: ById<NormalizedCardCategory>
  Order: ById<NormalizedOrder>
  CampaignShare: ById<NormalizedCampaignShare>
  Campaign: ById<NormalizedCampaign>
  Gift: ById<NormalizedGift>
  Card: ById<NormalizedCard>
  BankAccount: ById<NormalizedBankAccount>
  ItemCategory: ById<NormalizedItemCategory>
  Reminder: ById<NormalizedReminder>
  SendableCard: ById<NormalizedSendableCard>
  Item: ById<NormalizedItem>
  Recipient: ById<NormalizedRecipient>
  Image: ById<NormalizedImage>
  MarketingMultiParagraph: ById<NormalizedMarketingMultiParagraph>
  Collection: ById<NormalizedCollection>
  Group: ById<NormalizedGroup>
  ContactShare: ById<NormalizedContactShare>
}

export const NormalizedData = (): NormalizedData => ({
  Contact: {},
  ProductionInfo: {},
  MarketingParagraph: {},
  CreditCard: {},
  Invite: {},
  Layout: {},
  Notification: {},
  User: {},
  Prospect: {},
  CardCategory: {},
  Order: {},
  CampaignShare: {},
  Campaign: {},
  Gift: {},
  Card: {},
  BankAccount: {},
  ItemCategory: {},
  Reminder: {},
  SendableCard: {},
  Item: {},
  Recipient: {},
  Image: {},
  MarketingMultiParagraph: {},
  Collection: {},
  Group: {},
  ContactShare: {},
})
